import React, { useEffect } from "react";
import {
    addMonths,
    eachDayOfInterval,
    eachWeekOfInterval,
    endOfMonth,
    endOfWeek,
    format,
    isThisMonth,
    startOfMonth,
    startOfWeek,
    subMonths,
} from 'date-fns';

import CalendarOverridesDay from "./CalendarOverridesDay";
import { DAYS_OF_THE_WEEK } from "../../../../Helpers/DateTimeHelper";
import { ucfirst } from "../../../../Helpers/StringHelper";

const CalendarOverrides = (props) => {
    const [ currentDate, setCurrentDate ] = React.useState(new Date());
    const [ visibleDates, setVisibleDates ] = React.useState([]);

    const getVisibleStartDate = (date) => {
        return startOfWeek(startOfMonth(date), { weekStartsOn: 1});
    }

    const getVisibleEndDate = (date) => {
        return endOfWeek(endOfMonth(date), { weekStartsOn: 1});
    }

    const handleChange = (day, daySlots) => {
        let updatedOverrides = {...props.config.overrides};
        updatedOverrides[day] = daySlots;
        props.onChange('overrides', updatedOverrides);
    }

    const getVisibleDates = (date) => {
        let start = getVisibleStartDate(date);
        let end = getVisibleEndDate(date);

        let weeks = eachWeekOfInterval({
            start,
            end,
        }, { weekStartsOn: 1 });

        let days = [];
        weeks.map(week => {
            days.push(eachDayOfInterval({
                start: week,
                end: endOfWeek(week, { weekStartsOn: 1 }),
            }))
        });
        setVisibleDates(days);
    }

    useEffect(() => {
        getVisibleDates(currentDate);
    }, [ currentDate ]);

    return (
        <div className="margin-top-2">
            <div className="grid-x">
                <div className="cell small-12 text-right calendar-date-change">
                    { isThisMonth(currentDate) === false &&
                        <a onClick={e => setCurrentDate(subMonths(currentDate, 1)) }>
                            <i className="fa fa-chevron-left"></i>
                        </a>
                    }

                    <div className="calendar-date">
                        { format(currentDate, 'MMMM yyyy') }
                    </div>

                    <a onClick={e => setCurrentDate(addMonths(currentDate, 1)) }>
                        <i className="fa fa-chevron-right"></i>
                    </a>
                </div>
            </div>

            <div className="grid-x">
                { DAYS_OF_THE_WEEK.map(day => (
                    <div key={day}
                        className="cell auto"
                    >
                        { ucfirst(day) }
                    </div>
                ))}
            </div>

            <div className="grid-x">
                <div className="calendar-container cell small-12">
                    { visibleDates.map((week, index) => (
                        <div key={index} className="calendar-row grid-x">
                            { week.map(day => {
                                let dateIndex = format(day, 'yyyy-MM-dd');

                                return (
                                    <CalendarOverridesDay
                                        key={day}
                                        day={day}
                                        currentDate={currentDate}

                                        availability={props.config.availability}
                                        daySlots={props.config.overrides[dateIndex] ?? null}
                                        dayErrors={props.errors.overrides ? props.errors.overrides[dateIndex] : null}
                                        onChange={handleChange}
                                    />
                                )
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CalendarOverrides;
